module.exports = __webpack_public_path__ + "static/media/edit-icon.7f3849b7.svg";